import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Botão flutuante "voltar ao topo", aparece após rolar a página.
export function ScrollToTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShow(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-50 p-3 rounded-full bg-brand-500 hover:bg-brand-400 text-black shadow-lg shadow-brand-500/20 transition hover:scale-110"
    >
      <ArrowUp size={20} />
    </button>
  );
}
